/*
 * @Description: 
 * @Author: zml
 * @Date: 2023-04-19 19:42:50
 * @LastEditors: zml
 * @LastEditTime: 2023-04-27 14:04:54
 */
import { SET_TENANTINFO, DEL_TENANTINFO } from '../mutation-types'
          
const tenant = {
  namespaced: true,
  state: {
    tenantInfo: JSON.parse(localStorage.getItem('tenantInfo')) || {},
    token: localStorage.getItem('Token') || '',
  },
  mutations: {

    [SET_TENANTINFO] (state, data) {
      state.token = data.token
      localStorage.setItem('Token', data.token)
      state.tenantInfo = data.tenants[0]
      localStorage.setItem('tenantInfo', JSON.stringify(data.tenants[0]))
    },
    [DEL_TENANTINFO] (state) {
      state.token = ''
      state.tenantInfo = ''
      localStorage.removeItem('tenantInfo')
      localStorage.removeItem('Token')
    }
  },
  actions: {
    set_tenantInfo ({ commit }, data) {
      commit(SET_TENANTINFO, data)
    },
    logout ({ commit }) {
      commit(DEL_TENANTINFO)
    }
  },
  getters: {
    get_tenantInfo: state => {
        return state.tenantInfo
    }
  }
}

export default tenant
